enum RoutesPath {
  Home = '/',
  Dashboard = '/dashboard',

  // Auth
  SignIn = '/auth/sign-in',
  SignUp = '/auth/sign-up/:code',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/resetPassword',

  // Properties
  Properties = '/properties',
  PropertyDetails = '/properties/:id',
  PropertyPreview = '/properties/:id/preview',
  PropertyMediaFolder = '/properties/:id/folder/:folderId',

  // Organization
  Organization = '/organization',

  //External Sales
  ExternalSales = '/external-sales',
  ExternalSalesUsers = '/external-sales/:id',

  // Management
  Management = '/management',

  //Public urls
  TermConditions = '/term-conditions',
  PrivacyPolicy = '/privacy-policy',
}

export { RoutesPath };
